import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdTextField from '../../common/elemental/AfitdTextField';
import _isEmpty from 'lodash/isEmpty';

const styles = theme => ({
    root: {},
    declineMeetingText: {
        marginBottom: '5px',
    },
    reasonContainer: {
        width: '360px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginRight: '24px',
    },
    reason: {
        flexGrow: 1,
    },
    reasonInputRoot: {
        paddingRight: '10px',

        '&$reasonInputFocused $reasonInputNotchedOutline': {
            borderColor: `${theme.palette.secondary.main} !important`,
        },

    },
    reasonInput: {
        fontSize: '14px',
        borderColor: `${theme.palette.secondary.main} !important`,
    },
    reasonInputFocused: {

    },
    reasonInputNotchedOutline: {

    },
    reasonHelperText: {
        textAlign: 'right',
    },
    closeIconButton: {
        padding: '10px',
    },
    closeIcon: {
        color: 'rgba(17, 30, 20, 0.4)',
        fontSize: '14px',
    },
});

const getDefns = params => {
    const { props, isEnabled, setIsEnabled } = params;
    const { reason, setReason } = params;
    const { classes, declineReasonOnModify, onCancel } = props;
    const {
        reasonInput: reasonInputCls,
        reasonInputRoot: reasonInputRootCls,
        reasonInputFocused: reasonInputFocusedCls,
        reasonInputNotchedOutline: reasonInputNotchedOutlineCls,
        reasonHelperText: reasonHelperTextCls,
        ...otherClasses
    } = classes;

    let defns = {
        declineMeetingText: {
            variant: 'body2',
            value: 'Decline Meeting Reason:',
        },
        reason: {
            fullWidth: true,
            variant: 'outlined',
            size: 'small',
            multiline: true,
            InputProps: {
                readOnly: !isEnabled,
                classes: {
                    root: reasonInputRootCls,
                    focused: reasonInputFocusedCls,
                    notchedOutline: reasonInputNotchedOutlineCls,
                    input: reasonInputCls,
                },
            },
            inputProps: {
                maxLength: 200,
            },
            FormHelperTextProps: {
                className: reasonHelperTextCls,
            },
            value: reason,
            onClick: handleClickReason.bind(null, isEnabled, setIsEnabled),
            onChange: handleChangeReason.bind(null, setReason, declineReasonOnModify),
        },
        closeIconButton: {
            onClick: handleClickCloseIconButton.bind(null, onCancel, setReason, declineReasonOnModify),
        },
    };

    setClassNameInDefns(defns, otherClasses);

    return defns;
};

const handleChangeReason = (setReason, declineReasonOnModify, evt) => {
    if (_isEmpty(evt.target.value)) {
        declineReasonOnModify('');
        setReason('');
    } else {
        declineReasonOnModify(evt.target.value);
        setReason(evt.target.value);
    }
};

const focusOnReason = (reasonInputEl, reason) => {
    if (reasonInputEl.current) {
        reasonInputEl.current.focus();
        reasonInputEl.current.value = '';
        reasonInputEl.current.value = reason;
    }
};

const handleClickReason = (isEnabled, setIsEnabled) => {
    if (!isEnabled) {
        setIsEnabled(true);
    }
};

const handleClickCloseIconButton = (onCancel, setReason, declineReasonOnModify) => {
    if (onCancel) {
        onCancel();

        // Clear the decline reason field since the user hit the close button
        setReason('');
        declineReasonOnModify('');
    }
};

const InterviewDecline = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    const reasonInputEl = useRef();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, isEnabled, setIsEnabled, onCancel, onSave } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [reason, setReason] = useState('');
    const [requestFocus, setRequestFocus] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     // Reset reason to the passed in value (db value)
    //     setReason(value);
    // }, [value, isEnabled]);

    useEffect(() => {
        // Every time field is enabled, set focus (for convenience)
        if (isEnabled) {
            setRequestFocus(true);
        }
    }, [isEnabled]);

    useEffect(() => {
        // if requested focus, set focus and set requestFocus to false
        if (requestFocus) {
            focusOnReason(reasonInputEl, reason);
            setRequestFocus(false);
        }
    }, [requestFocus, reasonInputEl, reason]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        // value,
        onSave,
        onCancel,
        isEnabled,
        setIsEnabled,
        reason,
        setReason,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden) {
        return null;
    } else {
        return (
            <div {...defns.root}>
                <AfitdTypography {...defns.declineMeetingText} />
                <div {...defns.reasonContainer}>
                    <AfitdTextField {...defns.reason} inputRef={reasonInputEl} />
                    <div>
                        <IconButton {...defns.closeIconButton}>
                            <CloseIcon {...defns.closeIcon} />
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewDecline);
